import React from 'react';
import { PreQualifyResult } from '../../../Models/PreQualifyResult';
import CreditScoreIcon from '@mui/icons-material/CreditScore';
import { Button } from '@mui/material';
import { hasValue, LanguageTranslation } from '@amsanalytics/react-shared-library';
import { getWordingForLanguage } from '../../../Helpers/LanguageDictionary';;

export interface PreQualifyResultSummaryProps {
  customerName: string;
  clientName: string;
  preQualifyResult: PreQualifyResult;
  selectedLanguageId: string;
  languageTranslations: LanguageTranslation[];
  creditAppUrl?: string; // optional link the user can click to go and fill out the full credit application
  onRetry: () => void; // user wants to retry the pre-qualification
}

// Returns the lower end of credit range for the given credit score. Credit score ranges are +/- 25 points from the given score.
const getLowerCreditRange = (creditScore: string): number => {
  const creditScoreNumber = parseInt(creditScore, 10);
  return creditScoreNumber > 25 ? creditScoreNumber - 25 : 0;
}

// Returns the upper end of credit range for the given credit score. Credit score ranges are +/- 25 points from the given score.
const getUpperCreditRange = (creditScore: string): number => {
  const creditScoreNumber = parseInt(creditScore, 10);
  return creditScoreNumber > 825 ? 850 : creditScoreNumber + 25;
}

export default function PreQualifyResultSummary(props: PreQualifyResultSummaryProps) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
      <h3 style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', marginBottom: 0 }}><CreditScoreIcon color='primary' style={{ marginRight: '5px' }} />{getWordingForLanguage('prequalificationcomplete', props.selectedLanguageId)}</h3>
      <p>{getWordingForLanguage('thankyou', props.selectedLanguageId)} {props.customerName} {getWordingForLanguage('forcompletingprequalification', props.selectedLanguageId)}.
        {props.preQualifyResult.score && <> {getWordingForLanguage('yourscoreisinrange', props.selectedLanguageId)} <b>{getLowerCreditRange(props.preQualifyResult.score)} - {getUpperCreditRange(props.preQualifyResult.score)}.</b></>}
        <br /><br />
        {getWordingForLanguage('thanksforinterest', props.selectedLanguageId)} {props.clientName} {getWordingForLanguage('willbeincontact', props.selectedLanguageId)}.
      </p>
      {!hasValue(props.creditAppUrl) && <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}><Button onClick={() => props.onRetry()} color='primary' variant='outlined'>Ok</Button></div>}
      {hasValue(props.creditAppUrl) && <a href={props.creditAppUrl} style={{ textUnderlineOffset: '2px' }}>
        {getWordingForLanguage('filloutcreditapp', props.selectedLanguageId)}
      </a>}
    </div>
  );
}